import { render } from "./blockchain.vue?vue&type=template&id=2bc524d0&scoped=true"
import script from "./blockchain.vue?vue&type=script&lang=js"
export * from "./blockchain.vue?vue&type=script&lang=js"

import "./blockchain.vue?vue&type=style&index=0&id=2bc524d0&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc524d0"]])

export default __exports__